import styled from "styled-components";
export const CarBookingWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
